<template>
 <d-row>
      <d-col lg="8">
  <d-alert class="alert-royal-blue" :show="show_alert" theme="danger" ref="dalert" style="position:sticky;top:0;left:0;z-index:10000;" dismissible >
    <i class="fa fa-info mx-2"></i>
    <span id="warning">{{ error_msg }}</span> 
  </d-alert>

  <d-card class="card-small mb-4">
    <vue-element-loading :active="loading" spinner="bar-fade-scale" color="#FF6700"/>
    <!-- Card Header -->
    <d-card-header class="border-bottom">
       <d-button type="button" :disabled="loading" class="btn-accent" @click="save_form" data-toggle="tooltip" data-placement="top" title="Save Form" ><i class="material-icons">save_alt</i> Simpan</d-button>&nbsp;
    </d-card-header>

    <d-list-group flush>
      <d-list-group-item class="p-3">
        <d-row>
          <d-col>
            <d-form>
              <d-form-row>
                <!-- Full Name -->
                <d-col md="6">
                  <label for="feFullName">Nama Lengkap</label>
                  <d-form-input type="text" id="name" placeholder="Nama Lengkap" v-model.trim="fullname" disabled/>
                </d-col>

                <d-col md="6">
                  <label for="feMobilePhone">HP</label>
                  <d-form-input type="text" id="mobile_phone" placeholder="Nomor HP" v-model.trim="mobile_phone" disabled/>
                </d-col>
              </d-form-row>
              <d-form-row>
                <!-- transdate -->
                <d-col md="6" :class="{ 'form-group--error' : $v.transdate.$error }">
                  <label for="feTransdate">Tgl Transaksi</label>
                  <d-datepicker v-model.trim="transdate"></d-datepicker>
                  <div  class="verror" v-if="!loading && !$v.transdate.required">Harap isi kolom ini</div>
                </d-col>
                <!-- amount -->
                <d-col md="6" class="form-group">
                  <label for="feDonationAmount">Nilai Donasi</label>
                  <input id="amount" type="text" placeholder="nilai donasi" class="form-control" v-model="amount" @blur="frmt(1)" @focus="frmt(0)">
                  <div  class="verror" v-if="!loading && !$v.amount.required">Harap isi kolom ini</div>
                </d-col>
                <!-- id number -->
                <d-col md="6" class="form-group">
                  <label for="feDonationNumber">Nomor ID Donasi</label>
                  <input id="idnumber" type="text" placeholder="nomor id donasi" class="form-control" v-model.trim="idnumber" >
                  <div  class="verror" v-if="!loading && !$v.idnumber.required">Harap isi kolom ini</div>
                </d-col>
                <!-- receipt number -->
                <d-col md="6" class="form-group">
                  <label for="feDonationNumber">Nomor Tanda Terima</label>
                  <input id="rcptnumber" type="text" placeholder="nomor tanda terima" class="form-control" v-model.trim="rcptnumber" >
                  <div  class="verror" v-if="!loading && !$v.rcptnumber.required">Harap isi kolom ini</div>
                </d-col>
                <!-- pay method -->
                <d-col md="6" class="form-group">
                  <label for="feDonationNumber">Jenis Pembayaran</label>
                  <input id="paymethod" type="text" placeholder="jenis pembayaran" class="form-control" v-model.trim="paymethod" >
                  <div  class="verror" v-if="!loading && !$v.paymethod.required">Harap isi kolom ini</div>
                </d-col>

              </d-form-row>
              <!-- Memo -->
              <d-form-row>
                <d-col md="12" class="form-group">
                <label for="feInputMemo">Jenis Donasi</label>
                <textarea 
                    class="form-control w-100"
                    v-model.trim="description"
                    placeholder="description"
                    rows="3"
                    max-rows="6">{{ description }}
                </textarea>
               </d-col>
              </d-form-row>

            </d-form>
          </d-col>
        </d-row>
      </d-list-group-item>
    </d-list-group>
  </d-card>
      </d-col>
 </d-row>
</template>
<style>
.item {
  display: flex;
  align-items: center;
}

.item-name {
  font-size: 12px;
}
</style>
<script>
import VueElementLoading from 'vue-element-loading';
import env from '../../env.vue';
import { required } from 'vuelidate/lib/validators';

export default {
  components: {
    VueElementLoading,
  },
  name: 'user-info',
  data(){
    return {
      form:'',
      id:'',
      donation_id:'',
      transdate:'',
      amount:'',
      fullname:'',
      mobile_phone:'',
      description:'',
      idnumber:'',
      rcptnumber:'',
      paymethod:'',
      loading:false,
      old_data:[],
      error_msg:'',
      show_alert:false,
    }
  },
  validations:{
    transdate:{ required },
    amount:{ required },
    description:{ required },
    idnumber:{ required },
    rcptnumber:{ required },
    paymethod:{ required },
  },
  watch: {
    '$route.query.id'(newId,oldId){
      if (newId!=oldId){
        if ( newId==0 ) this.resetForm();
      }
    },
  },
  methods: {
    frmt(m){
        if (m==1) this.amount=new Intl.NumberFormat().format(this.amount);
        else
            this.amount=this.amount.toString().replace(/\.|\,/g,'')*1;
    },

    save_form(){
        let dthis=this;        
        if (this.donation_id>0) return;
        let submit=true;
        if (submit){
          this.loading=true;
          let d = new Date(this.transdate);
          let ye = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(d)
          let mo = new Intl.DateTimeFormat('en', { month: '2-digit' }).format(d)
          let da = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(d)          
          let ddate = `${ye}-${mo}-${da}`;
          this.frmt(0);
          if (this.amount<=0) { this.frmt(1);this.loading=false;return; }
          if (this.description==''){ this.loading=false;return; }
          if (this.idnumber==''){ this.loading=false;return;}
          if (this.rcptnumber==''){ this.loading=false;return;}
          if (this.paymethod==''){ this.loading=false;return;
}
          this.axios.post( env.server+'/donation/save',
          {
            transdate:ddate,
            donator_id:parseInt(this.id),
            amount:parseInt(this.amount),
            created_by:0,
            voided_by:0,
            description:this.description,
            idnumber:this.idnumber,
            rcptnumber:this.rcptnumber,
            paymethod:this.paymethod,
          }).then( resp=>{
            this.loading=false;
            this.frmt(1);
            this.donation_id=1;
            this.$buefy.toast.open({ message:'Data saved',
              position: 'is-bottom',
              type: 'is-success',
            });
          }).catch(e=>{
            if (e.response.status==500||e.response.status==400)
              this.pop_alert(JSON.parse(e.response.data).message);
            this.frmt(1);
            this.loading=false;
          })
        }
    },
    pop_alert(msg){
      if (msg==undefined) return;
      this.$refs.dalert.dismissed=false;
      this.show_alert=10;
      this.error_msg=msg;
    },
    resetForm(){
      var dthis=this;
      this.old_data={ 
      fullname:'',
      transdate:'',
      mobile_phone:'',
      amount:'',
      description:'',
      idnumber:'',
      rcptnumber:'',
      paymethod:'',
      }
      Object.keys(this.old_data).forEach( key=>{
        eval('dthis.'+key+'=\'\'');
      });        
    }
  },
  mounted(){
    this.id=this.$route.query.id;
    if ( this.id>0 ){
      this.loading=true;
      this.axios.get( env.server+'/donator/load/'+this.id).then(
        resp=>{
          resp.data = JSON.parse(resp.data);
          resp.data = resp.data.data;
          this.fullname=resp.data.fullname;
          this.mobile_phone=resp.data.mobile_phone;
          this.amount=resp.data.donation_amount;
          this.description=resp.data.description;
          this.idnumber=resp.data.idnumber;
          this.rcptnumber=resp.data.rcptnumber;
          this.paymethod=resp.data.paymethod;
          this.loading=false;
          this.frmt(1);
          }
      )
    } else {
      this.resetForm()
    }
    let d = new Date();
    let ye = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(d)
    let mo = new Intl.DateTimeFormat('en', { month: '2-digit' }).format(d)
    let da = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(d)
    let ddate = `${ye}-${mo}-${da}`;
    this.transdate=ddate;
  },
};
</script>
